// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import type { Department } from '../types';
import {
  subdepartmentSelector,
  loadingBySubdepartmentSelector,
} from "../../products/selectors";
import { findProductsBySubdepartment } from '../../products/actions';
import { Link } from 'react-router-dom';
import './DepartmentsSubNav.css';
import ProductSquare from '../../products/components/ProductSquare';
import type { SubDepartment } from "../types/SubDepartment";
import PageLoader from "../../common/components/PageLoader";

type Props = {
  hoveredDept: ?Department,
  hoveredSub: ?SubDepartment,
  setHoveredSub: (id: ?number) => void,
  setHoveredDept: (id: ?number) => void,
  departments: Department[],
  products: any[],
  isLoading: boolean,
  productIds: number[],
  findProductsBySubdepartment: (
    id: string | number,
    page?: number,
    perPage?: number,
  ) => void,
};

const DepartmentsSubNav = (props: Props) => {
  const {
    hoveredDept,
    hoveredSub,
    setHoveredSub,
    setHoveredDept,
    products,
    findProductsBySubdepartment,
    loading,
  } = props;
  
  useEffect(() => {
    if (hoveredSub?.id && products.length === 0) {
      findProductsBySubdepartment(hoveredSub.id);
    }
  }, [hoveredSub?.id, products.length]);

  if (!hoveredSub || !hoveredDept) return null;
      
  return (
    <div className="departments-subnav" 
      onMouseLeave={() => setHoveredSub(null)}
    >
      <div className="subnav-left">
        <ul className="subnav-list">
          {hoveredDept.subdepartments.filter((s) => s.products && s.products.length > 0).map((s, i) => (
            <Link to={`/departamentos/${hoveredDept.id}/${s.slug}/`} onClick={() => setHoveredDept(null)}>
              <li
                className={`subnav-item ${hoveredSub?.id === s.id ? 'hovered' : ''}`}
                key={s.id || i}
                onMouseEnter={() => setHoveredSub(s)}
              >
                {s.name}
              </li>
            </Link>
          ))}
        </ul>
      </div>
      <div className="subnav-right">
        {!loading ?
          hoveredSub && (<div className="products-preview">
              { products && (
                <div className="products-preview-row">
                  {products.slice(0, 4).map((product, i) => (
                    <div key={product && product.id} className="preview-product-square">
                      <ProductSquare
                        productImage={product.images && product.images[0]}
                        productName={product.name}
                        productManufacturer={product.manufacturer}
                        productListPrice={product.listPrice}
                        productPrice={product.price}
                        productUnit={product.unitForQuantity}
                        productSlug={product.slug}
                        productId={product.id}
                        parentProductId={product.productId}
                        productTotalOnHand={product.totalOnHand}
                        defaultQuantity={product.defaultQuantity}
                        incrementQuantity={product.incrementQuantity}
                        inStock={product.inStock}
                        discontinued={product.discontinued}
                        isGiftCard={product.isGiftCard}
                        analyticsViewSource={`departments-subnav`}
                        setHoveredDept={setHoveredDept}
                      />
                    </div>
                  ))}
                </div>
              )}
            {products.length > 3 && <div className="subnav-see-all">
              <Link to={`/departamentos/${hoveredDept.id}/${hoveredSub?.slug ? `${hoveredSub?.slug}/` : ''}`} onClick={() => setHoveredDept(null)}>
                <span>VER TODOS</span>
                <i className="fa fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>}
          </div>
        ) : <PageLoader text="Pesquisando..." />}
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    products: subdepartmentSelector(state, ownProps.hoveredSub?.id),
    loading: loadingBySubdepartmentSelector(state, ownProps.hoveredSub?.id),
  };
};

const mapDispatchToProps = (dispatch) => ({
  findProductsBySubdepartment: (id, page, perPage) =>
    dispatch(findProductsBySubdepartment(id, page, perPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentsSubNav);
